import { footNav } from "@/mocks/gossip";

const groups = [
  { title: "关于吃瓜吧", items: footNav.about, icon: "ri-information-line" },
  { title: "蹲帖玩法", items: footNav.play, icon: "ri-stack-line" },
  { title: "合作联系", items: footNav.biz, icon: "ri-briefcase-line" },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-2xl font-black tracking-wide text-background-50">吃瓜吧</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              吃瓜吧盖楼蹲帖，追帖连瓜不遗漏。持续吃瓜中，楼层跟进最新进展，更新随时顶上来。做一个理性、有趣、不造谣的瓜田。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-white/10 px-3 py-1 text-xs text-background-100">盖楼蹲帖</span>
              <span className="rounded-full bg-white/10 px-3 py-1 text-xs text-background-100">持续吃瓜</span>
              <span className="rounded-full bg-white/10 px-3 py-1 text-xs text-background-100">楼层跟进</span>
              <span className="rounded-full bg-white/10 px-3 py-1 text-xs text-background-100">理性瓜友</span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 md:col-span-7">
            {groups.map((g) => (
              <div key={g.title}>
                <h4 className="mb-3 flex items-center gap-1.5 text-sm font-semibold text-background-50">
                  <i className={"text-primary-400 " + g.icon}></i>{g.title}
                </h4>
                <ul className="space-y-2.5">
                  {g.items.map((it) => (
                    <li key={it}>
                      <a href="#top" className="text-sm text-background-200/70 transition hover:text-background-50">
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1240px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-200/60 sm:flex-row md:px-6">
          <span>© 2026 吃瓜吧 · 网络信息内容遵循平台规则，理性吃瓜，不信谣不传谣</span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-secondary-400"></i>内容由广大瓜友共建 · 请勿恶意灌水
          </span>
        </div>
      </div>
    </footer>
  );
}